export default __webpack_public_path__ + "static/media/Raider's Leggings of the Wicked Hearth.0bd341fd.jpg";